export default `
    <div class="sidebar-search-dropdown">
        <ul class="search-results"></ul>
    </div>
`;
